// @flow

export type PayloadProps = {
  [string]: Array<*> | string | number | boolean | (() => any),
}

type Payload = {
  path: string[],
  props?: PayloadProps,
}

type OpenModal = {|
  type: "OPEN_MODAL",
  payload: Payload,
|}

type CloseModal = {|
  type: "CLOSE_MODAL",
  payload: Payload,
|}

export type Action = OpenModal | CloseModal

// Path has this format: ["information", "summary"] ...
export const openModal = (path: string[], props?: PayloadProps): OpenModal => ({
  type: "OPEN_MODAL",
  payload: {
    path,
    props,
  },
})

export const closeModal = (path: string[]): CloseModal => ({
  type: "CLOSE_MODAL",
  payload: {
    path,
  },
})
